<section fxLayout="column">
  <div *ngIf="!finished" fxLayout="column">
    <svg class="contructsvg" xmlns="http://www.w3.org/2000/svg" height="256" width="256" viewBox="0 0 256 256">
      <g>
        <path id="path1" transform="rotate(0,128,128) translate(0,0.3196910615805) scale(7.99076004357068,7.99076004357068)  " fill="#FFFDFD" d="M10,29.956988L14,29.956988 14,31.956988 10,31.956988z M5.0000001,29.956988L9,29.956988 9,31.956988 5.0000001,31.956988z M0,29.956988L4.0000001,29.956988 4.0000001,31.956988 0,31.956988z M7.0000002,26.497996L11,26.497996 11,28.497996 7.0000002,28.497996z M2,26.497996L5.9999998,26.497996 5.9999998,28.497996 2,28.497996z M10,22.997996L14,22.997996 14,24.997996 10,24.997996z M25.284961,13.086692L21.399066,15.078074 21.404539,15.108623C21.446413,15.400059,21.397441,15.702291,21.255134,15.975099L18.257823,21.136661 17.970847,26.342034 19.270916,26.342034 19.512929,21.595108 23.142122,15.6752C23.431137,15.204207 24.046171,15.055209 24.517194,15.345205 24.723268,15.47164 24.867513,15.660473 24.940385,15.872346L24.962194,15.947198 28.44857,26.093032C28.869579,26.100032 29.399589,26.097032 29.844598,26.092032 28.917579,22.909073 26.579534,14.809176 26.579534,14.809176L26.563533,14.755177z M16.278502,11.199173L15.487557,15.860179 18.54123,14.295277z M20.302782,6.5851531L17.109519,8.9467171 20.342933,13.371966 24.048406,11.473039z M22.373422,5.9980068L25.858156,10.545604 27.589427,9.6583864 24.86688,5.9980068z M20.831968,3.9980102L25.826858,3.9980102 26.20685,4.4490094 30.223762,9.8469988C30.552755,10.289998 30.460756,10.916997 30.017766,11.245996 29.838769,11.379996 29.628774,11.443996 29.421779,11.443996 29.230535,11.443996 29.04124,11.389699 28.87807,11.284523L28.846582,11.261488 27.09468,12.159275 28.245567,13.661191C28.398569,13.861188 28.496572,14.100185 28.528572,14.349182 28.818578,15.354169 31.323627,24.030058 31.979639,26.269029 32.103641,26.697024 32.024641,27.146018 31.761634,27.503015 31.496629,27.863009 31.088621,28.073007 30.639614,28.081006 30.295606,28.087007 29.647594,28.097007 29.035581,28.097007 28.630575,28.097007 28.239566,28.093005 27.963562,28.080007 27.39855,28.056006 26.90254,27.695012 26.701538,27.161017L23.736738,18.531555 21.484033,22.206099 21.241022,26.984025C21.205019,27.744014,20.580986,28.342004,19.820945,28.342004L17.358815,28.342004C16.971794,28.342004 16.596774,28.181006 16.33076,27.900012 16.061745,27.617015 15.920738,27.231021 15.939739,26.842027L16.272634,20.827464 16.272385,20.814438C16.274279,20.749992,16.28246,20.685366,16.297173,20.621475L16.305029,20.593787 16.306018,20.589053 16.309468,20.578142 16.324175,20.526305 16.332504,20.50528 16.33586,20.494665 16.34691,20.468911 16.361165,20.432924 16.36802,20.419712 16.374465,20.404689 16.397865,20.362186 16.408327,20.342021 16.420662,20.320777 16.421304,20.319612 16.421535,20.319273 18.645481,16.489189 14.749571,18.485703 14.738977,18.493823C14.66854,18.543174,14.591767,18.583503,14.510528,18.613479L14.483085,18.622269 5.9444861,22.997996 9,22.997996 9,24.997996 5.0000001,24.997996 5.0000001,23.482012 4.7854149,23.591979C4.6394167,23.666989 4.4834088,23.701992 4.3303921,23.701992 4.2396466,23.701992 4.149649,23.689617 4.0629314,23.665649L4.0000001,23.643626 4.0000001,24.997996 0,24.997996 0,22.997996 3.3750995,22.997996 3.3655011,22.969246C3.240535,22.520984,3.4429056,22.032535,3.8734153,21.812028L13.265509,16.998902 14.664224,8.7532621C14.747228,8.3352726,14.984241,7.9922813,15.321259,7.7852868L19.884803,4.4052243 19.889406,4.4013095 19.898462,4.3951077 19.903503,4.3913736 19.964241,4.3500624 19.973981,4.3433914 20.000621,4.3288445 20.033044,4.3102174 20.046646,4.3037133 20.06224,4.2951975 20.081321,4.2871323 20.100654,4.2778883 20.132608,4.2654533 20.153482,4.2566304 20.162389,4.2538648 20.167743,4.2517815 20.195592,4.2264528C20.368392,4.0837598,20.590036,3.9980102,20.831968,3.9980102z M14.637987,1.9978986C14.451972,1.9978986 14.266957,2.0499001 14.104944,2.1589026 13.899928,2.2969065 13.759917,2.5099115 13.712913,2.756918 13.661909,3.0249248 13.722914,3.2999315 13.882926,3.532937 14.204952,4.0019488 14.835001,4.1399527 15.287037,3.837945 15.492054,3.6999416 15.631065,3.487936 15.679068,3.2399302 15.730072,2.9729233 15.669068,2.6969161 15.510055,2.4639106 15.302039,2.1629028 14.969013,1.9978986 14.637987,1.9978986z M14.655465,8.7738037E-05C15.616986,0.0074119568,16.567764,0.47461033,17.157185,1.3308821L17.158185,1.3308821C17.622221,2.0068989 17.795235,2.8179193 17.643223,3.6139393 17.495212,4.3899589 17.055177,5.0589757 16.404126,5.4979873 15.902086,5.834995 15.329041,5.9959991 14.759996,5.9959989 13.789919,5.9959991 12.828844,5.5289874 12.234796,4.6659656 11.76976,3.9909487 11.596746,3.1799283 11.748758,2.3839083 11.89577,1.6078892 12.336805,0.93787193 12.988856,0.49886131 13.497771,0.15685272 14.078552,-0.0043077469 14.655465,8.7738037E-05z" />
      </g>
    </svg>
    <p class="underconstruction">ADMIN AREA under construction</p>
  </div>

  <mat-tab-group #tabRef *ngIf="finished" class="viewAdmin">

    <mat-tab>
      <ng-template mat-tab-label>
        <img class="headerIcon" src="/assets/general/organisations.svg">
        <p class="mat-tab-headerText">{{'COMPONENTS.ADMIN.ORGANISATIONS' | i18next }}</p>
      </ng-template>

      <div *ngIf="organisations; else elseBlock" class="tablecontainer">

        <table [dataSource]="organizationDataSource" class="StockTable" fxFlexAlign="stretch" mat-table
                 matSort>
          <ng-container matColumnDef="Name">
            <th *matHeaderCellDef class="thName" mat-header-cell mat-sort-header sortActionDescription="Sort by Name">{{'COMPONENTS.ADMIN.NAME' | i18next }}</th>
            <td *matCellDef="let element" class="tdName" mat-cell>
              {{element.name}}
            </td>
          </ng-container>

          <ng-container matColumnDef="Delete">
            <th *matHeaderCellDef class="thDelete" mat-header-cell> {{'COMPONENTS.ADMIN.DELETE' | i18next }}</th>
            <td *matCellDef="let element" class="tdDelete" mat-cell>
              <img class="deleteIcon" src="/assets/general/delete_w.svg" (click)="deleteOrganization(element.id)">
            </td>
          </ng-container>
          <tr *matHeaderRowDef="displayedOrganizationColumns; sticky: true" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedOrganizationColumns;" mat-row></tr>
        </table>

      </div>
      <ng-template #elseBlock >
        <p class="noEntries">
          {{'COMPONENTS.ADMIN.NOENTRIES' | i18next }}
        </p>
      </ng-template>

      <img class="addNewIcon" src="/assets/general/AddCycle.svg" (click)="newOrganisations()">

    </mat-tab>



    <mat-tab>
      <ng-template mat-tab-label>
        <img class="headerIcon" src="/assets/general/user_w.svg">
        <p class="mat-tab-headerText">{{'COMPONENTS.ADMIN.USERS' | i18next }}</p>
      </ng-template>

      <div *ngIf="users; else elseBlock" class="tablecontainer">
        <table [dataSource]="usersDataSource" class="StockTable" fxFlexAlign="stretch" mat-table
               matSort>
          <ng-container matColumnDef="Name">
            <th *matHeaderCellDef class="thNameU" mat-header-cell>{{'COMPONENTS.ADMIN.NAME' | i18next }}</th>
            <td *matCellDef="let element" class="tdNameU" mat-cell>
              {{element.first_name}} {{element.last_name}}
            </td>
          </ng-container>
          <ng-container matColumnDef="E-Mail">
            <th *matHeaderCellDef class="thEmail" mat-header-cell>{{'COMPONENTS.ADMIN.EMAIL' | i18next }}</th>
            <td *matCellDef="let element" class="tdEmail" mat-cell>
              {{element.email}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Organization">
            <th *matHeaderCellDef class="thOrganisationU" mat-header-cell>{{'COMPONENTS.ADMIN.ORGANISATION' | i18next }}</th>
            <td *matCellDef="let element" class="tdOrganisationU" mat-cell>
              {{element.organization.name}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Delete">
            <th *matHeaderCellDef class="thDelete" mat-header-cell> {{'COMPONENTS.ADMIN.DELETE' | i18next }}</th>
            <td *matCellDef="let element" class="tdDelete" mat-cell>
              <img *ngIf="!element.is_superuser" class="deleteIcon" src="/assets/general/delete_w.svg" (click)="deleteUser(element.id)">
              <img *ngIf="element.is_superuser" class="deleteIconGray" src="/assets/general/delete_gray.svg">
            </td>
          </ng-container>
          <tr *matHeaderRowDef="displayedUserColumns; sticky: true" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedUserColumns;" mat-row></tr>
        </table>
      </div>
      <ng-template #elseBlock >
        <p class="noEntries">
          {{'COMPONENTS.ADMIN.NOENTRIES' | i18next }}
        </p>
      </ng-template>

      <img class="addNewIcon" src="/assets/general/AddCycle.svg" (click)="NewUser()">

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <img class="headerIcon" src="/assets/general/modules.svg">
        <p class="mat-tab-headerText">{{'COMPONENTS.ADMIN.MODULES' | i18next }}</p>
      </ng-template>
      <div *ngIf="modules; else elseBlock" class="tablecontainer">
        <table [dataSource]="modulesDataSource" class="StockTable" fxFlexAlign="stretch" mat-table matSort>
          <ng-container matColumnDef="Group">
            <th *matHeaderCellDef class="thGroup" mat-header-cell>{{'COMPONENTS.ADMIN.GROUP' | i18next }}</th>
            <td *matCellDef="let element" class="tdGroup" mat-cell>
              {{element.Module.Group}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Name">
            <th *matHeaderCellDef class="thNameM" mat-header-cell>{{'COMPONENTS.ADMIN.NAME' | i18next }}</th>
            <td *matCellDef="let element" class="tdNameM" mat-cell>
              {{element.Module.Name}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Serialnumber">
            <th *matHeaderCellDef class="thSerial" mat-header-cell>{{'COMPONENTS.ADMIN.SERIAL' | i18next }}</th>
            <td *matCellDef="let element" class="tdSerial" mat-cell>
              {{element.SerialNumber}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Organisation">
            <th *matHeaderCellDef class="thOrganisation" mat-header-cell>{{'COMPONENTS.ADMIN.ORGANISATION' | i18next }}</th>
            <td *matCellDef="let element" class="tdOrganisation" mat-cell>
              {{element.Ward.Name}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Delete">
            <th *matHeaderCellDef class="thDelete" mat-header-cell> {{'COMPONENTS.ADMIN.DELETE' | i18next }}</th>
            <td *matCellDef="let element" class="tdDelete" mat-cell>
              <img class="deleteIcon" src="/assets/general/delete_w.svg" (click)="deleteModule(element.SerialNumber)">
            </td>
          </ng-container>
          <tr *matHeaderRowDef="displayedModuleColumns; sticky: true" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedModuleColumns;" mat-row></tr>
        </table>
      </div>
      <ng-template #elseBlock >
        <p class="noEntries">
          {{'COMPONENTS.ADMIN.NOENTRIES' | i18next }}
        </p>
      </ng-template>

      <img class="addNewIcon" src="/assets/general/AddCycle.svg" (click)="newModule()">

    </mat-tab>

  </mat-tab-group>
</section>
